import {
  Button,
  FormControl,
  FormErrorMessage,
  FormLabel,
  IconButton,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  useDisclosure,
  useToast,
} from '@chakra-ui/react';
import { yupResolver } from '@hookform/resolvers/yup';
import React from 'react';
import { useForm } from 'react-hook-form';
import { FaPlus } from 'react-icons/fa';
import { useDispatch } from 'react-redux';
import * as yup from 'yup';
import { saveGoalTemplate } from '../../../stores/slices/fourBoxesTemplates/fourBoxesTemplatesActions';

const AddGoalTemplate = ({ category, templateId }) => {
  const schema = yup
    .object({
      goalItem: yup.string().required('Description is required'),
    })
    .required();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const dispatch = useDispatch();
  const toast = useToast();

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const onSaveItem = async data => {
    await dispatch(
      saveGoalTemplate({
        goalItem: data.goalItem,
        goalCategoryTemplateId: category.id,
        templateId,
        isCreating: true,
      })
    );
    reset();
    onClose();
    toast({
      description: 'Item has been added',
      colorScheme: 'primary',
      status: 'success',
      duration: 3000,
      isClosable: true,
      position: 'bottom-right',
      variant: 'primary',
    });
  };
  return (
    <React.Fragment>
      <IconButton
        aria-label="Add goal template"
        icon={<FaPlus />}
        variant={'outline'}
        size="sm"
        color={'primary'}
        onClick={onOpen}
      />

      <Modal closeOnOverlayClick={false} isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <form onSubmit={handleSubmit(onSaveItem)}>
            <ModalHeader>Add a goal template</ModalHeader>
            <ModalCloseButton />
            <ModalBody pb={6}>
              <FormControl id="goalItem" isInvalid={errors.goalItem}>
                <FormLabel>Item Description</FormLabel>
                <Input id="goalItem" {...register('goalItem')} />
                <FormErrorMessage>
                  {errors.goalItem && errors.goalItem.message}
                </FormErrorMessage>
              </FormControl>
            </ModalBody>

            <ModalFooter>
              <Button mr={3} type="submit" isLoading={isSubmitting}>
                Save
              </Button>
              <Button
                onClick={onClose}
                variant="outline"
                disabled={isSubmitting}
              >
                Cancel
              </Button>
            </ModalFooter>
          </form>
        </ModalContent>
      </Modal>
    </React.Fragment>
  );
};

export default AddGoalTemplate;
